import { cn } from "@/shared/lib/cn"

/**
 * Aviso legal de rodape de secao.
 *
 * Aparece sob "Como funciona", sob os planos, sob o FAQ e no rodape. E o texto
 * que diz que o site nao substitui o regulamento — repeti-lo com formatacoes
 * diferentes em cada lugar e o comeco de alguem reescrever a redacao de um deles.
 */
export interface DisclaimerProps {
  children: React.ReactNode
  className?: string
  /** `xs` para o comparativo de planos, onde o espaco e menor. */
  size?: "sm" | "xs"
  divider?: boolean
}

export function Disclaimer({ children, className, size = "sm", divider = true }: DisclaimerProps) {
  return (
    <p
      className={cn(
        "leading-relaxed",
        size === "sm" ? "text-xs text-verde-profundo/35" : "text-[10px] text-verde-profundo/32",
        divider && "border-t border-verde-profundo/8 pt-6",
        className,
      )}
    >
      {children}
    </p>
  )
}
